import { Component, OnInit, ViewChild, ViewChildren, QueryList, ElementRef, Input } from '@angular/core';
import { BasicInventionDetailsDataForm } from '../_models/basic-invention-details-data-form';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ValidationErrorMessageEnum } from '../constants/ValidationErrorMessageEnum';
import { BasicOfInventionDetailsService } from '../_services/basic-of-invention-details.service';
import { MatStepper, MatExpansionPanel, MatDialogConfig, MatDialog } from '@angular/material';
import { WhiteSpaceValidators } from '../shared/whitespace.validator';
import { SessionActivityDataForm } from '../_models/session-activity-data-form';
import { SesssionActivityService } from '../_services/sesssion-activity.service';
import { DialogComponent } from '../dialog/dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { SuccessDialogService } from '../_services/success-dialog.service';
import { Observable } from 'rxjs';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-basic-invention-details-save-update',
  templateUrl: './basic-invention-details-save-update.component.html',
  styleUrls: ['./basic-invention-details-save-update.component.css']
})

export class BasicInventionDetailsSaveUpdateComponent implements OnInit {
  basicInventionDetailsDataFormGroup: FormGroup;
  updateFlag = '';
  projectId: any;
  publishDate: Date;
  currentFileToUpload: File;
  userSession;
  applicationType: string = 'Complete';
  previousStep: string = 'Previous step';
  nextStep: string = 'Next step';
  maxDate = new Date();
  minDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
  _allExpandState = false;
  exceedsYear: boolean;
  inventionNameForSatus: string;
  doingStatusSelected: string = 'Basic Invention Details';
  projectTitle: string = 'Project Title';
  respForDailog;
  wordCount: number;
  lastSessionActivityNumber: number;
  sessionActivityDataForm: SessionActivityDataForm = new SessionActivityDataForm();
  sessionActivity;
  userDataSession;
  userDetailsId = 0;

  @ViewChild('stepper') stepper: MatStepper;
  @Input('matTooltip') message: string;
  @ViewChildren('tooltip') tooltips;
  @ViewChildren(MatExpansionPanel) viewPanels: QueryList<MatExpansionPanel>;
  @ViewChild('firstInput') firstInput: ElementRef;
  @ViewChild('seventhInput') seventhInput: ElementRef;
  @ViewChild('eightInput') eightInput: ElementRef;
  @ViewChild('ninthInput') ninthInput: ElementRef;
  @ViewChild('tenthInput') tenthInput: ElementRef;

  inventionPublishTypeList: string[] = [
    'Blogs',
    'Journals',
    'Videos',
    'Product in market',
    'Prospective buyer',
    'Others'
  ];
  inventionCategoryList: string[] = [
    'Machines (devices composed of interoperating parts)',
    'Manufactured articles (products made from raw materials)',
    'Compositions of matter (combinations of chemicals)',
    'Processes (sequences of steps)',
    'Combination of any of above',
    'Others'
  ];
  inventionProgressList: string[] = [
    'Just an idea',
    'Under development of working model',
    'Complete working model',
    'Final testing',
    'Commercialization'
  ]
  inventionTypeList: string[] = [
    'Provisional',
    'Complete'
  ]
  inventionTechCategoryList: string[] = [
    'Bio-Tech',
    'Bio-Medical',
    'Business process',
    'Chemical',
    'Electrical / Electronics',
    'Mechanical',
    'Networking',
    'Software',
    'Others',
  ]
  inventionDrawingStatusList: string[] = [
    'Yes',
    'No'
  ]

  get isDirty(): boolean {
    return JSON.stringify(this.originalDetails) !== JSON.stringify(this.currentDetails);
  }

  private currentDetails: BasicInventionDetailsDataForm = new BasicInventionDetailsDataForm();
  private originalDetails: BasicInventionDetailsDataForm = new BasicInventionDetailsDataForm();

  get basicInventionDetailsDataForm(): BasicInventionDetailsDataForm {
    return this.currentDetails;
  }
  set basicInventionDetailsDataForm(value: BasicInventionDetailsDataForm) {
    this.currentDetails = value;
    this.originalDetails = { ...value };
  }
  get inventionPublishDetails(): FormArray {
    return <FormArray>this.basicInventionDetailsDataFormGroup.get('inventionPublishDetailsGroup.inventionPublishDetails');
  }

  constructor(
    private formbuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private basicOfInventionDetailsService: BasicOfInventionDetailsService,
    private sesssionActivityService: SesssionActivityService,
    public dialog: MatDialog,
    private router: Router,
    private successDialogService: SuccessDialogService,
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.projectId = params['id'];
      this.updateFlag = 'true';
    });
  }

  ngOnInit() {
    this.basicInventionFormValidate();
    this.inventionPublishTypeLoop();

    // Watching input
    this.basicInventionDetailsDataFormGroup.get('inventionCategoryGroup.inventionCategory').valueChanges.subscribe(value => this.setInventionCategory(value));
    this.basicInventionDetailsDataFormGroup.get('inventionTechCategoryGroup.inventionTechCategory').valueChanges.subscribe(value => this.setInventionTechCategory(value));
    this.basicInventionDetailsDataFormGroup.get('inventionPublishDetailsGroup.inventionPublishStatus').valueChanges.subscribe(value => this.setInventionPubStatus(value));

    this.userSession = localStorage.getItem('currentUser');
    this.basicInventionDetailsDataForm.userSessionDataForm = JSON.parse(this.userSession);
    this.userDetailsId = this.basicInventionDetailsDataForm.userSessionDataForm.userDetailsId;
    if (this.updateFlag == 'true' && this.projectId > 0) {
      this.activatedRoute.data.subscribe(
        data => {
          const resolvedData: BasicInventionDetailsDataForm = data['resolvedData'];
          this.basicInventionDetailsRetrievedByProjectId(resolvedData);
        }
      )
    }
  }

  inventionPublishTypeLoop() {
    for (let i in this.inventionPublishDetails.controls) {
      this.inventionPublishDetails.get(i).get('inventionPublishType').valueChanges.subscribe(value => this.setInventionPubType(value));
    }
  }

  basicInventionFormValidate() {
    const maxWordPattern = "^(\\b[a-zA-Z\\d+#.-]+\\b(?:\\s+|$)){0,15}$";
    this.basicInventionDetailsDataFormGroup = this.formbuilder.group({
      inventionName: ['', [Validators.required, WhiteSpaceValidators.emptySpace(), Validators.pattern(maxWordPattern)]],
      inventionPublishDetailsGroup: this.formbuilder.group({
        inventionPublishStatus: ['', [Validators.required]],
        inventionPublishDetails: this.formbuilder.array([this.inventionPublishGroup()]),
      }),
      inventionCategoryGroup: this.formbuilder.group({
        inventionCategory: ['', [Validators.required]],
        inventionCategoryOthers: [''],
      }),
      inventionProgress: ['', [Validators.required]],
      inventionType: ['', [Validators.required]],
      inventionTechCategoryGroup: this.formbuilder.group({
        inventionTechCategory: ['', [Validators.required]],
        inventionTechCategoryOthers: [''],
      }),
      inventionProbSolution: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      inventionDescription: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      inventionComponents: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      inventionAdvantages: ['', [Validators.required, WhiteSpaceValidators.emptySpace()]],
      inventionDrawingStatus: ['', [Validators.required]]
    });
  }

  // ===== Add publish group in array =====
  addInventionPublishDetails(): void {
    this.inventionPublishDetails.push(this.inventionPublishGroup());
    this.setInventionPubStatus('Yes');
    this.inventionPublishTypeLoop();
  }

  // ===== Delete publish group in array =====
  deleteaddInventionPublishDetails(index: number): void {
    this.inventionPublishDetails.removeAt(index);
    this.inventionPublishDetails.markAsDirty();
  }

  // ===== Publish group copy using Refactor =====
  inventionPublishGroup(): FormGroup {
    return this.formbuilder.group({
      inventionPublishType: [''],
      inventionPublishTypeOthers: [''],
      inventionPublishDate: [''],
      inventionPublishLink: [''],
    })
  }

  // ===== Change Invention category others validation =====
  setInventionCategory(invCategory: string): void {
    const inventionCategoryOthersControl = this.basicInventionDetailsDataFormGroup.get('inventionCategoryGroup.inventionCategoryOthers');
    if (invCategory === 'Others') {
      inventionCategoryOthersControl.setValidators([Validators.required, WhiteSpaceValidators.emptySpace()]);
    }
    else {
      inventionCategoryOthersControl.clearValidators();
    }
    inventionCategoryOthersControl.updateValueAndValidity();
  }

  // ===== Change Invention Technicial category others validation =====
  setInventionTechCategory(invTechCategory: string): void {
    const inventionTechCategoryOthersControl = this.basicInventionDetailsDataFormGroup.get('inventionTechCategoryGroup.inventionTechCategoryOthers');
    if (invTechCategory === 'Others') {
      inventionTechCategoryOthersControl.setValidators([Validators.required, WhiteSpaceValidators.emptySpace()]);
    }
    else {
      inventionTechCategoryOthersControl.clearValidators();
    }
    inventionTechCategoryOthersControl.updateValueAndValidity();
  }

  // ===== Change Invention publish details validation =====
  setInventionPubStatus(invPubStatus: string): void {

    for (let i in this.inventionPublishDetails.controls) {
      const inventionPublishTypeControl = this.inventionPublishDetails.get(i).get('inventionPublishType');
      const inventionPublishDateControl = this.inventionPublishDetails.get(i).get('inventionPublishDate');
      const inventionPublishLinkControl = this.inventionPublishDetails.get(i).get('inventionPublishLink');
      if (invPubStatus === 'Yes') {
        inventionPublishTypeControl.setValidators([Validators.required]);
        inventionPublishDateControl.setValidators([Validators.required]);
        inventionPublishLinkControl.setValidators([Validators.required, WhiteSpaceValidators.emptySpace()]);
      }
      else {
        inventionPublishTypeControl.clearValidators();
        inventionPublishDateControl.clearValidators();
        inventionPublishLinkControl.clearValidators();
      }
      inventionPublishTypeControl.updateValueAndValidity();
      inventionPublishDateControl.updateValueAndValidity();
      inventionPublishLinkControl.updateValueAndValidity();
    }
  }

  // ===== Change Invention publish type others validation =====
  setInventionPubType(invPubType: string): void {
    for (let i in this.inventionPublishDetails.controls) {
      const inventionPublishTypeOthersControl = this.inventionPublishDetails.get(i).get('inventionPublishTypeOthers');
      if (invPubType === 'Others') {
        inventionPublishTypeOthersControl.setValidators([Validators.required, WhiteSpaceValidators.emptySpace()]);
      }
      else {
        inventionPublishTypeOthersControl.clearValidators();
      }
      inventionPublishTypeOthersControl.updateValueAndValidity();
    }
  }

  // ===== Date checking for one year =====
  checkOneYear(): void {
    let checkValue = this.basicInventionDetailsDataFormGroup.get('inventionPublishDetailsGroup.inventionPublishStatus').value;
    let checkValid = this.inventionPublishDetails.valid;
    let exceedsYear: boolean;
    if (checkValue === 'Yes' && checkValid === true) {
      for (let inner in this.inventionPublishDetails.controls) {
        let selectedDate = this.inventionPublishDetails.get(inner).get('inventionPublishDate').value;
        if (selectedDate < this.minDate) {
          exceedsYear = true;
          if (exceedsYear === true) {
            break;
          }
        }
      }
      if (exceedsYear === true) {
        this.openDialog();
      }
      const inventionPublishArray = this.inventionPublishDetails;
    }
  }

  // ===== Date dialog =====
  openDialog(): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    const dialogRef = this.dialog.open(DialogComponent, dialogConfig);
  }

  // ===== Unsaved changes confirm dialog =====
  confirmDialog(): boolean | Observable<boolean> | Promise<boolean> {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '450px',
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == true) {
        this.saveFormField();
      }
      if (result == false) {
        this.doingStatusSelected = 'Basic Invention Details';
      }
    })
    return dialogRef.afterClosed();
  }

  getWordCount() {
    this.wordCount = ((this.basicInventionDetailsDataForm.inventionName || '').match(/\S+/g) || []).length;
  }

  // ===== Stepper tooltip =====
  getStepperIndexVaule(value) {
    switch (value) {
      case 1:
        this.message = "Name your invention";
        break;
      case 2:
        this.message = "Have you published your invention in any form or disclosed to anyone";
        break;
      case 3:
        this.message = "Your invention is about";
        break;
      case 4:
        this.message = "Progress of your invention";
        break;
      case 5:
        this.message = "Type of application";
        break;
      case 6:
        this.message = "Mention the technical area of your invention";
        break;
      case 7:
        this.message = "List the problems/ drawback and solution addressed by your invention";
        break;
      case 8:
        this.message = "Briefly describe your invention";
        break;
      case 9:
        this.message = "List out the components / process and steps involved in your invention with its working";
        break;
      case 10:
        this.message = "Mention the advantages & application of your invention";
        break;
      case 11:
        this.message = "Can your invention be represented in any form of drawings";
      default:
        break;
    }
  }

  public set allExpandState(value: boolean) {
    this._allExpandState = value;
    this.togglePanels(value);
  }

  public togglePanels(value: boolean) {
    this.viewPanels.forEach(p => value ? p.open() : p.close());
  }

  expandLess(value) {
    switch (value) {
      case 1:
        this.firstInput.nativeElement.focus();
        break;
      case 7:
        this.seventhInput.nativeElement.focus();
        break;
      case 8:
        this.eightInput.nativeElement.focus();
        break;
      case 9:
        this.ninthInput.nativeElement.focus();
      case 10:
        this.tenthInput.nativeElement.focus();
      default:
        break;
    }
  }

  saveFormField() {
    this.sessionActivityDataForm.activityType = 6
    let indexNumber = this.stepper.selectedIndex + 1;
    this.sessionActivityDataForm.lastActivitySession = indexNumber;
    this.basicInventionDetailsDataForm.sessionActivityDataForm = this.sessionActivityDataForm;
    let arrayObj = this.basicInventionDetailsDataFormGroup.get('inventionPublishDetailsGroup.inventionPublishDetails') as FormArray;
    this.basicInventionDetailsDataForm.inventionPublishDetails = JSON.stringify(arrayObj.value);
    this.projectTitle = this.basicInventionDetailsDataForm.inventionName;
    const currentUser = localStorage.getItem('currentUser');
    this.basicInventionDetailsDataForm.userSessionDataForm = JSON.parse(currentUser);
    this.inventionNameForSatus = this.basicInventionDetailsDataForm.inventionName;
    this.basicOfInventionDetailsService.saveAndUpdateBasicInventionDetails(this.basicInventionDetailsDataForm).subscribe(
      resp => {
        this.basicInventionDetailsDataForm = resp as BasicInventionDetailsDataForm;
      }, error => {
        console.log(error);
      })
  }

  gotoDrawing() {
    this.sessionActivityDataForm.activityType = 6
    let indexNumber = this.stepper.selectedIndex + 1;
    this.sessionActivityDataForm.lastActivitySession = indexNumber;
    this.basicInventionDetailsDataForm.sessionActivityDataForm = this.sessionActivityDataForm;
    let arrayObj = this.basicInventionDetailsDataFormGroup.get('inventionPublishDetailsGroup.inventionPublishDetails') as FormArray;
    this.basicInventionDetailsDataForm.inventionPublishDetails = JSON.stringify(arrayObj.value);
    const currentUser = localStorage.getItem('currentUser');
    this.basicInventionDetailsDataForm.userSessionDataForm = JSON.parse(currentUser);
    this.basicOfInventionDetailsService.saveAndUpdateBasicInventionDetails(this.basicInventionDetailsDataForm).subscribe(
      resp => {
        this.basicInventionDetailsDataForm = resp as BasicInventionDetailsDataForm;
        let projectId = this.basicInventionDetailsDataForm.projectDataForm.projectId;

        this.sesssionActivityService.getProjectLastSessionActiityForRedirection(this.userDetailsId, 6, projectId).subscribe(
          resp => {
            this.respForDailog = resp;
            if (this.basicInventionDetailsDataForm.inventionDrawingStatus === "Yes") {
              if (this.respForDailog.activityType < 7) {
                this.successDialogService.successDialogDoing(6, projectId);
              } else {
                this.router.navigate(['/main/patentDrawing', projectId]);
              }
            } else if (this.basicInventionDetailsDataForm.inventionDrawingStatus === "No") {
              if (this.respForDailog.activityType < 8) {
                this.successDialogService.successDialogDoing(7, projectId);
              } else {
                this.router.navigate(['/main/patentSearch', projectId]);
              }
            }
          ``}, error => {
            console.log(error);
          })
      }, error => {
        console.log(error);
      })
  }

  getErrorMsgForFormOfInvention() {
    return this.basicInventionDetailsDataFormGroup.controls.formOfInvention.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  getErrorMsgForDateOfPublised() {
    return this.basicInventionDetailsDataFormGroup.controls.dateOfPublised.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  getErrorMsgForApplicationType() {
    return this.basicInventionDetailsDataFormGroup.controls.applicationType.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  getErrorMsgForInventionProgress() {
    return this.basicInventionDetailsDataFormGroup.controls.inventionProgress.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  getErrorMsgForinventionName() {
    return this.basicInventionDetailsDataFormGroup.controls.inventionName.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  getErrorMsgForTechnicalInventionType() {
    return this.basicInventionDetailsDataFormGroup.controls.technicalInventionType.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  getErrorMsgForpublicationType() {
    return this.basicInventionDetailsDataFormGroup.controls.publicationType.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  getErrorMegForInventionDescription() {
    return this.basicInventionDetailsDataFormGroup.controls.inventiondescription.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  getErrorMsgForProblemSolved() {
    return this.basicInventionDetailsDataFormGroup.controls.problemsSolved.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  getErrorMsgForAdvantage() {
    return this.basicInventionDetailsDataFormGroup.controls.advantage.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  getErrorMsgForDrawings() {
    return this.basicInventionDetailsDataFormGroup.controls.drawings.errors.required ? ValidationErrorMessageEnum.REQUIRED :
      '';
  }

  setPublishDate(event) {
    this.publishDate = new Date(event.target.value);
  }

  onFileChange(event) {
    const files = event.target.files;
    this.currentFileToUpload = files[0];
  }

  basicInventionDetailsRetrievedByProjectId(basicInventionDetailsDataForm: BasicInventionDetailsDataForm) {

    this.basicInventionDetailsDataForm = basicInventionDetailsDataForm;

    // get form array reference
    let Obj = JSON.parse(this.basicInventionDetailsDataForm.inventionPublishDetails);
    if (this.basicInventionDetailsDataForm.inventionPublishStatus == "Yes" && Obj.length > 0) {
      const inventionPublishArray = this.inventionPublishDetails;
      // empty form array
      while (inventionPublishArray.length) {
        inventionPublishArray.removeAt(0);
      }
      // use patchValue instead of setValue
      inventionPublishArray.patchValue(Obj);
      // add form array values in a loop
      Obj.forEach(demoObj => inventionPublishArray.push(this.formbuilder.group(demoObj)))
    }
    this.sesssionActivityService.getProjectLastSessionActiityByUserId(this.userDetailsId, 6, this.projectId).subscribe(
      resp => {
        this.sessionActivity = resp;
        if (this.sessionActivity == null) {
        } else {
          this.lastSessionActivityNumber = this.sessionActivity.lastActivitySession - 1;
          this.stepper._stepHeader.forEach(
            step => {
              if (step.index <= this.lastSessionActivityNumber) {
                this.stepper.selectedIndex = step.index;
              }
            })
        }
      }, error => {
        console.log(error);
      })
  }
}